import { sortBy, uniq } from 'lodash';
import moment from 'moment';
import { useMemo } from 'react';

export function useGroupedLeads(leads = []) {
    return useMemo(() => {
        const sponsorIds = uniq(leads.map((lead) => lead.sponsor_id));

        let result = sponsorIds
            .map((sponsorId) => {
                let sponsorLeads = leads.filter((lead) => lead.sponsor_id === sponsorId);

                sponsorLeads = sortBy(sponsorLeads, lead => -1 * moment(lead.scan_datetime_utc).valueOf())

                return {
                    title: sponsorLeads[0].sponsor_name,
                    sponsorId: sponsorId,
                    items: sponsorLeads.map((lead) => lead.participant),
                };
            })
            .filter((item) => item.items.length > 0);

        result = sortBy(result, ['title']);

        return result;
    }, [leads]);
}
